import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

const EnhancedRaisedButton = (props) => {
    const { loading, icon, ...rest } = props;

    let buttonIcon = icon;

    if (loading) {
        buttonIcon = <CircularProgress
            size={ 20 }
            thickness={ 2 }
            style={ {
                lineHeight: 0,
                marginLeft: 12,
                marginRight: 0,
                verticalAlign: 'middle',
            } }
        />;
    }

    return (
        <RaisedButton
            icon={ buttonIcon }
            { ...rest }
        />
    );
};

EnhancedRaisedButton.propTypes = {
    loading: PropTypes.bool,
    icon: PropTypes.node,
};

export default EnhancedRaisedButton;



// WEBPACK FOOTER //
// ./src/components/button/EnhancedRaisedButton.js